import { GRIDMASTERS_SHIELD_640 } from "../assets/brandMarks";

// The 640px master shield, same artwork as brand/logos/GM-Logo-white.webp.
// (The inline 320px nav mark looked pixelated at loader size on Retina -
// client, 2026-09-19.) Inlined as a data URI (assets/brandMarks.js) rather
// than fetched: on a slow line the file sat behind the JS bundle and the hero
// preload, and the loader showed as a black screen with no logo for seconds
// (client, 2026-10-22). The static pre-React shield in public/index.html
// carries the same bytes, so the handoff is pixel-identical and instant.
export const SHINE_MARK_SRC = GRIDMASTERS_SHIELD_640;

/**
 * ShineMark - the loading mark (client, 2026-09-19): the Grid Masters shield
 * held STATIC, with a ray of light sweeping across and through it. The sweep
 * is a moving gradient band masked to the shield's own alpha, so the light
 * only exists inside the logo. Used by the page Loader and the rulebook
 * DownloadOverlay.
 */
export default function ShineMark({ size = 240, className = "", testid = "shine-mark" }) {
  return (
    <div className={`gm-shine ${className}`} style={{ width: size }} data-testid={testid} aria-hidden="true">
      <img src={SHINE_MARK_SRC} alt="" className="gm-shine__mark" width={640} height={640} draggable="false" />
      <span className="gm-shine__ray" style={{ WebkitMaskImage: `url(${SHINE_MARK_SRC})`, maskImage: `url(${SHINE_MARK_SRC})` }} />
    </div>
  );
}
